
// import React, { useState } from 'react';
// import "./ConfirmPassword.scss";
// import logoImg from "../../assets/Component 1.svg";
// import { useHistory } from "react-router-dom";
// import LoadingComman from '../LoadingComman/LoadingComman';
// import { useParams } from 'react-router-dom/cjs/react-router-dom';
// import {API_URL} from '../../services/apiconfig';
// import axios from 'axios';

// const ConfirmPassword = () => {
//   const { userId } = useParams();
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [passwordError, setPasswordError] = useState('');
//   const history = useHistory();
//   const [loading, setLoading] = useState(false);

// console.log(userId);
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'newPassword') {
//       setNewPassword(value);
//     } else if (name === 'confirmPassword') {
//       setConfirmPassword(value);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
  
//     if (newPassword !== confirmPassword) {
//       setPasswordError("Passwords do not match");
//       return;
//     }

  
//     try {
//       const response = await axios.patch(`${API_URL}/api/user/newPassword/${userId}`, null, {
//         params: { password: newPassword }, // ✅ Corrected parameter name
//       });
    
      
//       console.log("Password updated successfully:", response.data);
//       history.push("/");
//     } catch (error) {
//       console.error("Error updating password:", error.response?.data || error.message);
//     } finally {
//       setLoading(false);
//     }
//   };
  

//   return (
//     <div className="forgot-password">
//       {loading && <LoadingComman />}

//       {!loading && (
//       <div className="forgot-password-container">
//         <div className="forgot-password-form">
//           <div className="forgot-password-content">
//             <div className="forgot-password-logo">
//               <img src={logoImg} alt="" />
//             </div>
//             <div className="forgot-password-head">
//             <h2>Reset Password</h2>
//             </div>
//             <form className="add-form" onSubmit={handleSubmit}>
//             <div className="add-form1">
//               <label className="data-q">Enter new password</label>
//               <input
//                 type="password"
//                 className="edit-input"
//                 name="newPassword"
//                 value={newPassword}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div className="add-form1">
//               <label className="data-q">Re-enter new password again</label>
//               <input
//                 type="password"
//                 className="edit-input"
//                 name="confirmPassword"
//                 value={confirmPassword}
//                 onChange={handleChange}
//                 required
//               />
//               {passwordError && <p className="error">{passwordError}</p>}
//             </div>
//             <div className="">
              
//               <button type="submit" className='btn'>Confirm</button>
//             </div>
//           </form>
           
//           </div>
//         </div>
//         <div className="forgot-password-img">
//           <div className="forgot-password-img-box"></div>

//         </div>
//       </div>
//  )}
//     </div>
    
//   );
// };

// export default ConfirmPassword;

import React, { useState } from 'react';
import logoImg from "../../assets/Component 1.svg";
import { useHistory } from "react-router-dom";
import LoadingComman from '../LoadingComman/LoadingComman';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { API_URL } from '../../services/apiconfig';
import axios from 'axios';

const ConfirmPassword = () => {
  const { userId } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  console.log(userId);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'newPassword') {
      setNewPassword(value);
    } else if (name === 'confirmPassword') {
      setConfirmPassword(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return;
    }

    try {
      const response = await axios.patch(`${API_URL}/api/user/newPassword/${userId}`, null, {
        params: { password: newPassword },
      });

      console.log("Password updated successfully:", response.data);
      history.push("/");
    } catch (error) {
      console.error("Error updating password:", error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-screen bg-amber-50/40">
      {loading && <LoadingComman />}

      {!loading && (
        <div className="flex flex-row-reverse h-full">
          {/* Form Section */}
          <div className="w-full md:w-1/2 h-full bg-white flex items-center justify-center">
            <div className="w-4/5 lg:w-3/5">
              <div className="flex justify-center items-center my-5">
                <img src={logoImg} alt="Logo" />
              </div>
              <div className="text-center mb-6">
                <h2 className="text-2xl font-semibold text-gray-800">Reset Password</h2>
              </div>
              <form className="w-full" onSubmit={handleSubmit}>
                <div className="mb-6">
                  <label className="block text-gray-700 mb-1 text-[#5d596c]">Enter new password</label>
                  <input
                    type="password"
                    className="w-full rounded-lg border-2 border-gray-300/30 p-3 text-[#6f6b7d] outline-none focus:border-[#676765] focus:shadow-sm"
                    name="newPassword"
                    value={newPassword}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-6">
                  <label className="block text-gray-700 mb-1 text-[#5d596c]">Re-enter new password again</label>
                  <input
                    type="password"
                    className="w-full rounded-lg border-2 border-gray-300/30 p-3 text-[#6f6b7d] outline-none focus:border-[#676765] focus:shadow-sm"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={handleChange}
                    required
                  />
                  {passwordError && <p className="text-[#F44336] mt-2">{passwordError}</p>}
                </div>
                <div className="mt-8">
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-[#fc7e14] text-white rounded-md font-bold text-base hover:bg-[#e87213] transition-colors"
                  >
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Image Section */}
          <div className="hidden md:flex md:w-1/2 h-full bg-[#676765] items-center justify-center">
            <div className="w-3/4 h-full">
              {/* Background or image content can go here */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfirmPassword;
